import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyCreateOffer = lazy(() => import('./CreateOffer'));

export const CreateOffer: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyCreateOffer {...props} />
	</Suspense>
);
